import { siteInfo } from "@/mocks/siteContent";

const genreLinks = ["恋爱漫画", "奇幻漫画", "校园漫画", "悬疑漫画", "完结漫画", "排行榜"];
const quickLinks = [
  { label: "首页", href: "#home" },
  { label: "漫画分类", href: "#categories" },
  { label: "热门推荐", href: "#hot" },
  { label: "完结排行榜", href: "#ranking" },
  { label: "常见问题", href: "#faq" },
  { label: "联系我们", href: "#contact" },
];

export default function Footer() {
  return (
    <footer className="w-full bg-primary-900 text-white">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <a href="#home" className="flex items-center gap-2 font-heading text-xl">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-white/15 text-white">
                <i className="ri-book-open-fill text-lg" aria-hidden="true" />
              </span>
              {siteInfo.brand}
            </a>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-white/75">
              {siteInfo.description}
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {siteInfo.tags.map((t) => (
                <a
                  key={t}
                  href="#categories"
                  className="rounded-full bg-white/10 px-3 py-1 text-xs text-white/80 transition-colors hover:bg-white/20"
                >
                  #{t}
                </a>
              ))}
            </div>
          </div>

          <nav aria-label="题材分类">
            <h4 className="text-sm font-bold text-white">题材分类</h4>
            <ul className="mt-4 space-y-2.5">
              {genreLinks.map((g) => (
                <li key={g}>
                  <a href="#categories" className="text-sm text-white/70 transition-colors hover:text-white">
                    {g}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="快速导航">
            <h4 className="text-sm font-bold text-white">快速导航</h4>
            <ul className="mt-4 space-y-2.5">
              {quickLinks.map((q) => (
                <li key={q.label}>
                  <a href={q.href} className="text-sm text-white/70 transition-colors hover:text-white">
                    {q.label}
                  </a>
                </li>
              ))}
            </ul>
            <a href={`mailto:${siteInfo.email}`} className="mt-4 inline-flex items-center gap-2 text-sm text-white/80">
              <i className="ri-mail-line" aria-hidden="true" />
              {siteInfo.email}
            </a>
          </nav>
        </div>
      </div>

      <div className="border-t border-white/15">
        <div className="mx-auto flex w-full max-w-7xl flex-col items-center justify-between gap-3 px-4 py-5 text-xs text-white/60 sm:flex-row md:px-6">
          <p>© {new Date().getFullYear()} {siteInfo.brand} · 用心为你推荐每一部好漫画</p>
          <p className="flex items-center gap-2">
            <span>高清画质 · 每日更新 · 分类齐全</span>
          </p>
        </div>
      </div>
    </footer>
  );
}